import {Component} from '@angular/core';

@Component({
  selector: 'app-modal-ttn-status-show',
  templateUrl: './modal-ttn-status-show.component.html',
  styleUrls: ['./modal-ttn-status-show.component.scss']
})
export class ModalTtnStatusShowComponent {
  public isNumberTtnModalShow: boolean = false;
  public isDarkBackground: boolean = false

  ttnModalShow() {
    this.isNumberTtnModalShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isNumberTtnModalShow = false;
    this.isDarkBackground = false;
  }
}
